<div class="sh-page-template__main__wrapper">
  <div class="sh-page-template__main__content">
    <div class="sh-template-stack">
      <sh-page-header class="sh-template-stack__item" [title]="'batches.title' | translate"></sh-page-header>

      <digihaven-table-header class="sh-template-stack__item" [title]="tableHeaderWithCount$ | async"></digihaven-table-header>

      <div class="sh-template-stack__item">
        <div class="sh-card-table-wrapper">
          <table class="sh-card-table" id="batches-overview">
            <thead>
              <tr>
                <th scope="col" width="300">{{ "batches.columns.name" | translate }}</th>
                <th scope="col" width="250">{{ "batches.columns.label" | translate }}</th>
                <th scope="col" width="250">{{ "batches.columns.commencement" | translate }}</th>
                <th scope="col" width="250">{{ "batches.columns.finalisation" | translate }}</th>
                <th scope="col" width="200">{{ "batches.columns.completed" | translate }}</th>
                <th scope="col" width="200">{{ "batches.columns.skipped" | translate }}</th>
                <th scope="col" width="250">{{ "batches.columns.remark" | translate }}</th>
                <th scope="col" width="200">{{ "batches.columns.status" | translate }}</th>
                <th scope="col" class="sh-card-table__col--small">{{ "batches.columns.actions" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @if (loading$ | async) {
                <tr>
                  <td [colSpan]="COLUMN_COUNT">{{ "ui.loading" | translate }}</td>
                </tr>
              }

              @if (error$ | async) {
                <tr class="sh-card-table__row--error">
                  <td [colSpan]="COLUMN_COUNT">{{ "batches.messages.failed-to-fetch" | translate }}</td>
                </tr>
              }

              @if ((batches$ | async)?.length === 0) {
                <tr class="sh-card-table__row--update">
                  <td [colSpan]="COLUMN_COUNT">{{ "batches.messages.empty-list" | translate }}</td>
                </tr>
              } @else {
                @if (actionItems$ | async; as actionItems) {
                  @for (batch of batches$ | async; track trackByBatchId(i, batch); let i = $index) {
                    <tr>
                      <th scope="row" [id]="batch.Id">
                        <header class="sh-list-row-title">
                          <h3 class="sh-list-row-title__title -sh-wrap">{{ batch.Label }}</h3>
                        </header>
                      </th>
                      <td>
                        <span class="-sh-wrap-text">{{ batch.Tag }}</span>
                      </td>
                      <td>
                        <time [dateTime]="batch.StartDate">{{ batch.StartDate | readableDate: true }}</time>
                      </td>
                      <td>
                        <time [dateTime]="batch.FinishDate">{{ batch.FinishDate | readableDate: true }}</time>
                      </td>
                      <td>
                        <span class="-sh-wrap-text">{{ batch.Completed }}</span>
                      </td>
                      <td>
                        <span class="-sh-wrap-text">
                          {{ batch.Skipped }}
                        </span>
                      </td>
                      <td>
                        <span class="-sh-wrap-text">
                          {{ getSkippedInfoMsg(batch) }}
                        </span>
                      </td>
                      <td>
                        @if (batch.Status$ | async; as status) {
                          @if (status === "InProgress") {
                            <sh-progress-label [type]="batch.LabelType$ | async" [percentage]="batch.Progress">
                              {{ "batches.status." + status | translate }}
                            </sh-progress-label>
                          } @else {
                            <sh-label [type]="batch.LabelType$ | async">{{ "batches.status." + status | translate }}</sh-label>
                          }
                        }
                      </td>
                      <td class="sh-card-table__col--small">
                        @if (actionItems[i]; as group) {
                          <sh-action-group [actionGroup]="group"></sh-action-group>
                        }
                      </td>
                    </tr>
                  }
                }
              }

            </tbody>
          </table>
        </div>
      </div>

      <sh-pagination
        class="sh-template-stack__item"
        [paginationInfo]="paginationInfo$ | async"
        [previousPageMsg]="'components.pagination.previous' | translate"
        [nextPageMsg]="'components.pagination.next' | translate"
        [perPageMsg]="'components.pagination.per-page' | translate"
        (paginationInfoChanged)="paginationInfoChanged($event)"
      ></sh-pagination>
    </div>
  </div>
</div>
